import on from 'dom-event';
import select from 'dom-select';

export default (el) => {
  const loginBtn = select('.header-account-links__link--login', el);
  if (!loginBtn) return;
  on(loginBtn, 'click', () => {
    window.dataLayer.push({
      event: 'login_start',
      component_name: 'global',
      module_name: 'unlock free shipping',
      shopify_module_name: 'header account links'
    })
  });
}
